import React, { useState } from 'react';
import { AppShell } from './components/layout/AppShell';
import { CataloguePage } from './pages/CataloguePage';
import { ScalePreviewPanel } from './components/monitor/ScalePreviewPanel';
import { MonitorDetailView } from './components/monitor/MonitorDetailView';
import { UserMonitorSetup } from './components/monitor/UserMonitorSetup';
import { Modal } from './components/ui/Modal';
import { useUserMonitor } from './hooks/useUserMonitor';
import type { Monitor } from './types/Monitor';

function App() {
  const [selectedMonitor, setSelectedMonitor] = useState<Monitor | null>(null);
  const [setupOpen, setSetupOpen] = useState(false);
  const { config: userConfig, isConfigured, setConfig } = useUserMonitor();

  return (
    <>
      <AppShell
        onMyMonitorClick={() => setSetupOpen(true)}
        userConfig={userConfig}
        isConfigured={isConfigured}
        rightPanel={
          <ScalePreviewPanel
            monitor={selectedMonitor}
            userConfig={userConfig}
          />
        }
        detailOverlay={
          selectedMonitor ? (
            <MonitorDetailView
              monitor={selectedMonitor}
              userConfig={userConfig}
              onDismiss={() => setSelectedMonitor(null)}
            />
          ) : undefined
        }
      >
        <CataloguePage onSelectMonitor={setSelectedMonitor} />
      </AppShell>

      <Modal
        open={setupOpen}
        onClose={() => setSetupOpen(false)}
        ariaLabel="Configure your monitor"
      >
        <UserMonitorSetup
          config={userConfig}
          onSave={(next) => { setConfig(next); setSetupOpen(false); }}
          onCancel={() => setSetupOpen(false)}
        />
      </Modal>
    </>
  );
}

export default App;

